import {
  Calendar,
  Phone,
  MapPin,
  Clock,
  Star,
  Award,
  Heart,
  Shield,
  Building2,
  Package,
  Stethoscope,
  PlusCircle,
  Baby,
  Bone,
  Brain,
  Microscope,
  ChevronRight,
  Download,
  CheckCircle,
  Trophy,
  BadgeIcon as Certificate,
  User,
  ArrowRight,
} from "lucide-react"

import { BlogCard } from "../blog-card"
import { Link } from "react-router-dom"
import { Button } from "../ui/button"
import { Badge } from "../ui/badge"



export default function Locationswidget() {
  return (
         <section className="py-12 bg-gray-100">
                  <div className="container px-4 mx-auto">
                    <div className="flex flex-col items-center mb-10 text-center">
                      <Badge className="mb-2">Locations</Badge>
                      <h2 className="mb-4 text-3xl font-bold md:text-4xl">Our Branches</h2>
                      <p className="max-w-2xl text-muted-foreground">
                        Visit one of our conveniently located hospitals across Hyderabad and surrounding areas.
                      </p>
                    </div>
        
                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
                      <div className="bg-white rounded-lg overflow-hidden shadow-md relative">
                        <img
                          src="/images/madinaguda-branch.jpeg"
                          alt="Madinaguda Branch"
                          width={300}
                          height={200}
                          className="w-full h-48 object-cover"
                        />

                        <div className="p-4">
                          <h3 className="text-xl font-bold">Madinaguda</h3>
                          <div className="flex items-center gap-2 mt-2">
                            <MapPin className="w-4 h-4 text-primary" />
                            <span className="text-sm">Plot No. 89, Madinaguda</span>
                          </div>
                          <div className="flex items-center gap-2 mt-2">
                            <Phone className="w-4 h-4 text-primary" />
                            <span className="text-sm">+91 99660 60000</span>
                          </div>
                          <div className="mt-4">
                            <Button variant="outline" size="sm" className="w-full" asChild>
                              <Link to="/locations/madinaguda">View Details</Link>
                            </Button>
                          </div>
                        </div>
                      </div>
        
                      <div className="bg-white rounded-lg overflow-hidden shadow-md relative">
                        <img
                          src="/images/nallagandla-branch.png"
                          alt="Nallagandla Branch"
                          width={300}
                          height={200}
                          className="w-full h-48 object-cover"
                          
                        />

                        <div className="p-4">
                          <h3 className="text-xl font-bold">Nallagandla</h3>
                          <div className="flex items-center gap-2 mt-2">
                            <MapPin className="w-4 h-4 text-primary" />
                            <span className="text-sm">Plot No. 1, Nallagandla</span>
                          </div>
                          <div className="flex items-center gap-2 mt-2">
                            <Phone className="w-4 h-4 text-primary" />
                            <span className="text-sm">+91 99660 60000</span>
                          </div>
                          <div className="mt-4">
                            <Button variant="outline" size="sm" className="w-full" asChild>
                              <Link to="/locations/nallagandla">View Details</Link>
                            </Button>
                          </div>
                        </div>
                      </div>
        
                      <div className="bg-white rounded-lg overflow-hidden shadow-md relative">
                        <img
                          src="/images/isnapur-branch.png"
                          alt="Isnapur Branch"
                          width={300}
                          height={200}
                          className="w-full h-48 object-cover"
                        />

                        <div className="p-4">
                          <h3 className="text-xl font-bold">Isnapur</h3>
                          <div className="flex items-center gap-2 mt-2">
                            <MapPin className="w-4 h-4 text-primary" />
                            <span className="text-sm">Isnapur, Patancheru</span>
                          </div>
                          <div className="flex items-center gap-2 mt-2">
                            <Phone className="w-4 h-4 text-primary" />
                            <span className="text-sm">+91 99660 60000</span>
                          </div>
                          <div className="mt-4">
                            <Button variant="outline" size="sm" className="w-full" asChild>
                              <Link to="/locations/isnapur">View Details</Link>
                            </Button>
                          </div>
                        </div>
                      </div>
        
                      <div className="bg-white rounded-lg overflow-hidden shadow-md relative">
                        <img
                          src="/images/zaheerabad-branch.png"
                          alt="Zaheerabad Branch"
                          width={300}
                          height={200}
                          className="w-full h-48 object-cover"
                        />

                        <div className="p-4">
                          <h3 className="text-xl font-bold">Zaheerabad</h3>
                          <div className="flex items-center gap-2 mt-2">
                            <MapPin className="w-4 h-4 text-primary" />
                            <span className="text-sm">Zaheerabad</span>
                          </div>
                          <div className="flex items-center gap-2 mt-2">
                            <Phone className="w-4 h-4 text-primary" />
                            <span className="text-sm">+91 99660 60000</span>
                          </div>
                          <div className="mt-4">
                            <Button variant="outline" size="sm" className="w-full" asChild>
                              <Link to="/locations/zaheerabad">View Details</Link>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
    
  );
}

 